module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-person-045bea04.svg";